export default __webpack_public_path__ + "static/media/uncleban.accfe1ff.png";